






























import {Component, Prop, Vue} from 'vue-property-decorator';
import {IProduct} from '@/models/IProduct';

@Component({})
export default class ProductView extends Vue {
  @Prop() product!: IProduct;
  @Prop({ default: false }) icon!: boolean;
  @Prop({ default: false }) small!: boolean;


  get img() {
    return this.product.image === '' ? 'https://cdn.vuetifyjs.com/images/parallax/material2.jpg' : this.product.image;
  }

  get imgSize() {
    return this.small ? 30 : 60;
  }
}
